import React from "react";

export default function Step6() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          6
        </div>
        <h1 className="">
          Um e-mail será enviado para a sua caixa de entrada. <br />
          <b>VERIFIQUE TAMBÉM O SPAM.</b>
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px] flex items-start flex-wrap gap-5">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3609.jpg?alt=media&token=3a706a04-af95-42f8-a839-3df00613546c"
          className="w-72"
          alt=""
        />
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3610.jpg?alt=media&token=08ae4946-8c57-4c41-84b6-221e0e6fbaec"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
